export default {
  directoryTree: 'Directory tree',
  expandAll: 'Expand All',
  collapseAll: 'Collapse All',
  pleaseFillInTheDeviceNumber: 'Please fill in the device number',
  demonstrateAssociatedMeasurementPoints: 'Demonstrate associated measurement points',
  PleaseSelectAListOfDevices: 'Please select a list of devices',
  pleaseFillInTheDeviceName: 'Please fill in the device name',
  parentNode: 'Parent node',
  measurementPointCodeOrMeasurementPointName: 'Measurement point code or measurement point name',
  pleaseFillInTheParentNode: 'Please fill in the parent node',
  belongsToTheProject: 'Project',
  pleaseFillInTheItem: 'Please fill in the item',
  setStartStopRules: 'Set start-stop rules',
  directoryName: 'Directory name',
  theBatchDeletionIsSuccessful: 'The batch deletion is successful',
  ifLeftBlankItIsTheRootDirectory: 'If left blank, it is the root directory',
  enterAkeywordSearchQueryHere: 'Enter a keyword search query here',
  pleaseFillInTheDirectoryName: 'Please fill in the directory name',
  sort: 'Sort',
  measurementPointsHaveBeenAdded: 'Measurement points have been added',
  pleaseSelectTheDeviceName: 'Please select the device name',
  deviceCategoryAcquisitionFailed: 'Device category acquisition failed',
  measurementPointType: 'Measurement point type',
  addAssociatedMeasurementPoints: 'Add associated measurement points',
  numberOfMeasurementPoints: 'Number of measurement points',
  pleaseEnterAPositiveInteger: 'Please enter a positive integer',
  pleaseEnterTheDeviceCode: 'Please enter the device code',
  pleaseEnterADeviceName: 'Please enter a device name',
  containerLevel: 'Container level',
  thePanelWasDeletedSuccessfully: 'The panel was deleted successfully',
  panelDeletionFailed: 'Panel deletion failed',
  failedToAddPanel: 'Failed to add panel',
  theMaximumNumberOfPanelsHasBeenReached: 'The maximum number of panels has been reached',
  flameHeight: 'Flame height',
  dynamicModelCoding: 'Dynamic model coding',
  container: 'Container',
  modelEditing: 'Model editing',
  thePanelNameIsRequired: 'The panel name is required',
  panelCodingIsRequired: 'Panel coding is required',
  theNumberOfImpressionsIsRequired: 'The number of impressions is required',
  founder: 'Founder',
  aListOfDynamicModels: 'A list of dynamic models',
  theCurrentModelDoesNotExist: 'The current model does not exist',
  confirmReset: 'Confirm reset?',

  deletethisBank: 'Delete this bank',
  itIsForbiddenToSetTheSameRuleForTheSameSeasurementPoint:
    'It is forbidden to set the same rule for the same measurement point',
  addALineBelow: 'Add a line below',
  pleaseSelectAMeasurementPoint: 'Please select a measurement point',
  setUpRules: 'Set up rules',
  colorPriorityIsDisplayedInTheOrderInWhichTheRulesAreSet:
    'Color priority is displayed in the order in which the rules are set',
  activateTheTool: 'Activate the tool',
  numbersAreCreatedAutomaticallyByTheBackground:
    'Numbers are created automatically by the background',
  pleaseSelectTheMeasurementPointCode: 'Please select the measurement point code',
  Autofill: 'Autofill',
  dynamicModelNumbering: 'Dynamic model numbering',
  pleaseSelectDynamicModel: 'Please select Dynamic Model',
  sceneModel: 'Scene model',
  numberOfImpressions: 'Number of impressions',
  deletesTheCurrentlySelectedPanel: 'Deletes the currently selected panel',
  panelName: 'Panel name',
  measurementPointDrive: 'Measurement point drive',
  panelContent: 'The contents of the measurement point displayed by the panel',
  startTheThresholdAalarmSwitch: 'Start the threshold alarm switch',
  theMaximumNumberOfMeasurementPointsIs8: 'The maximum number of measurement points is 8',
  panelNumber: 'Panel number',
  createAMeasurementPointDisplayPanel: 'Create a measurement point display panel',
  panelManagement: 'Panel management',
  panelNameNumber: 'Panel name/number',
  panelSwitch: 'Panel switch',
  theMeasurementPointRequestFailed: 'The measurement point request failed',
  theCurrentDeviceDoesNotHaveAMeasurementPointAssociatedWithIt:
    'The current device does not have a measurement point associated with it',
  pleaseEnterTheDeviceNumber: 'Please enter the device number',
  disassociate: 'Disassociate',
  ruleCategoryAcquisitionFailed: 'Rule category acquisition failed',
  enableTheRuleSwitch: 'Enable the rule switch',
  theSceneModelIsAutomaticallyEchoed: 'The scene model is automatically echoed',
  pleaseSelectADeviceCategory: 'Please select a device category',
  dynamicModelListFetchFailed: 'Dynamic model list fetch failed',
  associateModel: 'Associate model',
  setEffect: 'set dynamic Effect',
  setRule: 'set Rules',
  rulesSetting: 'rules setting',
  synchronizeData: 'Synchronize data',
  pointCode: 'Measuring point coding',
  pointName: 'Name of Measuring point',
  uncheckTheAssociation: 'Uncheck the association',
  dynamicModelname: 'Dynamic model name',
  dynamicModelCategories: 'Category',
  motor: 'Motor',
  selectEditNode: 'Select Edit node',
  doYouWantToSaveModelNodeInformation: 'Do you want to save model node information?',
  modelTools: 'Model tools',
  dynamicModelAssociation: 'Dynamic model association',
  selectColumnFirst: 'Please select the Measurement Point column',
  confirmUnlink:
    'Confirm that you want to cancel the associated motion of the currently selected measuring point ?',
  editTheTableOfContents: 'Edit the table of contents',
  theCurrentDeviceDoesNotHaveASceneModelAssociatedWithIt:
    'The current device does not have a scene model associated with it',
  addANewDirectory: 'Add a new directory',
  auxiliaryMachines: 'Auxiliary machines',
  deleteTheDevice: 'Delete the device',
  dissolveTheRelationshipSuccessfully: 'Dissolve the relationship successfully',
  thisActionIsIrreversible: 'This action is irreversible',
  youCannotSelectYourselfAsTheParentNode: 'You cannot select yourself as the parent node',
  thereAreMultipleSubdirectoriesAssociatedWithThisDirectory:
    'There are multiple subdirectories associated with this directory, please delete all subdirectories before you can delete them!',
  pleaseDeleteAllDevicesBeforeYouCanDeleteThem:
    'There are multiple devices associated with this directory, please delete all devices before you can delete them!',
  whetherToConfirmTheDeletionOfTheCurrentNode:
    'Whether to confirm the deletion of the current node',
  theNodeDeletionSucceeded: 'The node deletion succeeded',
  theNewNodeIsAdded: 'The new node is added',
  failedToAddNewNode: 'Failed to add new node',
  theNodeWasEditedSuccessfully: 'The node was edited successfully',
  whetherToDeleteTheSelectedData: 'Whether to delete the selected data?',
  pleaseSelectTheDataYouWantToDelete: 'Please select the data you want to delete',
  measurementPointAssociation: 'Measurement point association',
  selectTheDirectoryTreeNodeFirst: 'Select the directory tree node first',
  theMeasurementPointOperationWasSuccessful: 'The measurement point operation was successful',
  theMeasurementPointOperationFailed: 'The measurement point operation failed',
}
